import { jsx as _jsx } from "react/jsx-runtime";
var Percent = function Percent(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.45 3.55a.74.74 0 0 0-1.047 0L3.551 15.403a.738.738 0 0 0 0 1.048c.29.289.758.289 1.048 0L16.451 4.598a.741.741 0 0 0 0-1.047Zm-3.116 12.283c-.689 0-1.25-.56-1.25-1.25 0-.689.561-1.25 1.25-1.25.69 0 1.25.561 1.25 1.25 0 .69-.56 1.25-1.25 1.25Zm0-4.166a2.92 2.92 0 0 0-2.916 2.916 2.92 2.92 0 0 0 2.916 2.917 2.92 2.92 0 0 0 2.917-2.917 2.92 2.92 0 0 0-2.917-2.916ZM6.668 5c.689 0 1.25.56 1.25 1.25S7.357 7.5 6.668 7.5c-.69 0-1.25-.56-1.25-1.25S5.978 5 6.668 5Zm0 4.167A2.92 2.92 0 0 0 9.584 6.25a2.92 2.92 0 0 0-2.916-2.917A2.92 2.92 0 0 0 3.75 6.25a2.92 2.92 0 0 0 2.917 2.917Z",
      fill: color
    })
  });
};
export default Percent;